import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ModalHostComponent } from '@pool-league/frontend-shared-feature-modal';

@Component({
  imports: [RouterModule, ModalHostComponent],
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {}
